import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	LogoImg: styled.img`
		height: 180px;
	`,
	AreaTitle: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;

		& > h2 {
			${({theme}) => theme.font.small_bold};
		}
	`,

	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,

	VoucherTableDiv: styled.div`
			display: flex;
			flex-wrap: wrap;
			border-top: 1px solid ${({ theme }) => theme.color.grey2};
	`,
	
	VoucherItem: styled.div`
			display: flex;
			border-bottom: 1px solid ${({ theme }) => theme.color.grey2};
	`,
	
	VoucherRow: styled.div`
		flex-basis: 50%;
		flex-grow: 1;
		display: flex;
		align-items: center;

		& > p {
			${({theme}) => theme.font.small};
			font-size: 12px;
			padding: 11px 20px;
		}
	`,

	VoucherRowRight: styled.div`
		flex-basis: 50%;
		flex-grow: 1;
		display: flex;
		align-items: center;

		& > p {
			${({theme}) => theme.font.small};
			font-size: 12px;
			padding: 11px 20px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				padding: 11px 10px;
			}
		}
	`,

	VoucherLabelLeft: styled.h2`
		${({theme}) => theme.font.small_bold};
		font-size: 12px;
		min-width: 200px;
		display: flex;
		align-items: center;
		width: 200px;
		background-color: ${({theme}) => theme.color.grey1};
		padding: 13px 20px;
		height: 100%;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 40px;
			width: 40px;
			padding: 11px 10px;
			justify-content: center;
		}
	`,

	VoucherLabelRight: styled.h2`
		${({theme}) => theme.font.small_bold};
		font-size: 12px;
		min-width: 200px;
		display: flex;
		align-items: center;
		width: 200px;
		background-color: ${({theme}) => theme.color.grey1};
		padding: 13px 20px;
		height: 100%;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 80px;
			width: 80px;
			padding: 11px 10px;
			justify-content: center;
		}
	`,
}

export default Style
